export enum PrequalificationStep {
  BusinessInformation = 'Business Information',
  AddressInformation = 'Address Information',
  BusinessMetrics = 'Business Metrics',
  Owners = 'Owners',
}

export enum BusinessInformationFormInput {
  BusinessName = 'Business Name or DBA',
  LegalBusinessName = 'Legal Business Name',
  BusinessEntityStructure = 'Business Entity Structure',
  FederalTaxId = 'Federal Tax ID',
  YearsInBusiness = 'Years in Business',
  YearIncorporated = 'Year Incorporated',
  PhoneNumber = 'Main Business Phone Number',
  MainBusinessEmail = 'Main Business Email',
  BusinessWebsite = 'Business Website',
  StatesWhereOperate = 'Select States Where You Operate',
}

export enum BusinessMetricsFormInput {
  PrimaryHomeImprovementCategory = 'Primary Home Improvement Category',
  OtherHomeImprovementCategory = 'Other Home Improvement Category',
  DoYouInstallTheProductsYourself = 'Do You Install The Products yourself?',
  HoldAppropriateLicense = 'Do you hold the appropriate license(s)?',
  AnnualJobs = 'Annual Jobs / Units Sold',
  PercentOfSalesFinanced = 'Percent of Sales Financed',
  AnnualRevenue = 'Annual Revenue',
  HowDidYouHearAboutHfs = 'How did you hear about HFS?',
  PleaseSpecifyHomeImprovementType = 'Please Specify Home Improvement Type',
  HowManyInstallersDoYouHave = 'How Many Installers Do You Have?',
  ExplainSpecificLicense = 'Please explain why you do not hold this specific license',
}

export enum BusinessEntityStructure {
  Corporation = 'Corporation',
  LimitedLiabilityCompany = 'Limited Liability Company (LLC)',
  Partnership = 'Partnership',
  SoleProprietorship = 'Sole Proprietorship',
}

export enum AddressInformationFormInput {
  LocationStreet = 'Street',
  LocationCity = 'City',
  LocationState = 'State',
  LocationZipCode = 'Zip Code',
  MailingStreet = 'Mailing Street',
  MailingCity = 'Mailing City',
  MailingState = 'Mailing State',
  MailingZipCode = 'Mailing Zip Code',
  IsThisTheMailingAddress = 'Is this the mailing address?',
}

export enum DefaultYesNoQuestion {
  Yes = 'Yes',
  No = 'No',
}

export enum OwnersAmount {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
}

export enum PrimaryHomeImprovementCategory {
  Additions = 'Additions',
  AduAttached = 'ADU - Attached',
  AduDetached = 'ADU - Detached',
  Basements = 'Basements',
  Bathrooms = 'Bathrooms',
  DeckingOrPatio = 'Decking / Patio',
  Electrical = 'Electrical',
  Fences = 'Fences',
  Flooring = 'Flooring',
  Hardscape = 'Hardscape',
  HomeAutomation = 'Home Automation',
  HomeEntertainment = 'Home Entertainment (mancave theater etc.)',
  HotTubs = 'Hot Tubs',
  Hvac = 'HVAC',
  Kitchens = 'Kitchens',
  Landscape = 'Landscape',
  MetalBuildings = 'Metal Buildings',
  Other = 'Other',
  OutdoorKitchens = 'Outdoor Kitchens',
  Pergolas = 'Pergolas',
  RoleBarns = 'Pole Barns',
  RoofAsphalt = 'Roof - Asphalt',
  RoofMetal = 'Roof - Metal',
  RoofShingles = 'Roof - Shingles',
  RoofTile = 'Roof - Tile',
  Saunas = 'Saunas',
  Security = 'Security',
  Solar = 'Solar',
  Siding = 'Siding',
  Spas = 'Spas',
  Sunrooms = 'Sunrooms / Three Seasons Rooms / Four Seasons Rooms',
  SwimmingPoolsInground = 'Swimming Pools - Inground',
  SwimmingPoolsAboveGround = 'Swimming Pools - Above Ground',
  SwimmingPoolsSemiInground = 'Swimming Pools - Semi-Inground',
  SwimmingPoolsRemodel = 'Swimming Pools - Remodel / Renovation',
  WaterTreatment = 'Water Treatment',
  Windows = 'Windows',
}

export enum OwnersFormInput {
  HowManyOwners = 'How many Owners (include owners(s) with 25%+ ownership)',
  UserId = 'id',
  FirstName = 'firstName',
  LastName = 'lastName',
  Position = 'position',
  IsSalesperson = 'isSalesperson',
  CellPhone = 'cellPhone',
  Email = 'email',
  PercentageOwned = 'percentageOwned',
  PrimarySalesFirstName = 'First Name',
  PrimarySalesLastName = 'Last Name',
  PrimarySalesPosition = 'Position',
  PrimarySalesCellPhone = 'Cell Phone',
  PrimarySalesEmail = 'Email',
  IsMainContact = 'isMainContact',
}

export enum InputLabel {
  FirstName = 'First Name',
  LastName = 'Last Name',
  Position = 'Position',
  IsSalesperson = 'Also a Salesperson?',
  Email = 'Email',
  Phone = 'Cell Phone',
  PercentageOwnedOfCompany = 'Percentage Owned',
}

export enum OwnersPosition {
  CSuiteOrPresident = 'C-Suite, President / VP',
  FinanceManager = 'Finance Manager',
  SalesManager = 'Sales Manager',
  Salesperson = 'Salesperson',
  Employee = 'Employee',
}

export enum PrequalificationStepType {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  Empty = 'Empty',
}

export enum PrequalificationEntrySource {
  Registration = 'Registration',
  Portal = 'Portal',
}
